import { render, staticRenderFns } from "./CustomCarNumber.vue?vue&type=template&id=270d339e"
import script from "./CustomCarNumber.vue?vue&type=script&lang=js"
export * from "./CustomCarNumber.vue?vue&type=script&lang=js"
import style0 from "./CustomCarNumber.vue?vue&type=style&index=0&id=270d339e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports